import $ from 'jquery';
window.$ = window.jQuery = $;

// import 'bootstrap';
// window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

import './plugins/lazy-load';
import './image-galleries';

import './partials/line-animation';
import './partials/char-animation';
import './partials/header';

import './component-sets/page-hero';
import './component-sets/chapter-hero';
import './component-sets/form-ajax';

import './chapter-components/scroll-magic';
import './chapter-components/aos';